import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AncillariesTapService {
	private _ancillaries: any;
	private readonly _observableAncillaries: BehaviorSubject<any[]>;
	private _ancillariesLoaded: boolean;

	constructor(protected _http: HttpClient) {
		this._ancillariesLoaded = false;
		this._observableAncillaries = new BehaviorSubject(this.ancillaries);
	}

	get ancillariesLoaded(): boolean {
		return this._ancillariesLoaded;
	}

	get observableAncillaries() {
		return this._observableAncillaries;
	}

	get ancillaries() {
		return this._ancillaries;
	}

	set ancillaries(ancillaries) {
		this._ancillaries = ancillaries;
	}

	/** Reads JSON file and import mock data for ancillaries */
	readAncillariesInitializerFile() {
		const url = './assets/data/ancillaries.json';
		const filePromise = this._http.get(url).toPromise();
		return filePromise;
	}
	
	/** Reads JSON file and import mock data for ancillaries */
	readConfirmationAncillariesInitializerFile() {
		const url = './assets/data/ancillaries-confirmation.json';
		const filePromise = this._http.get(url).toPromise();
		return filePromise;
	}

	ancillariesInitializerFile(): Observable<any> {
		const url = './assets/data/ancillaries.json';
		return this._http.get(url);
	}
}
